import { Component } from '@angular/core';
import { StationService } from '@accounts/user/services/station.service';
import { MapService } from '@accounts/user/services/map.service';
import { TariffService } from '@accounts/user/services/tariff.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { FormControl, FormGroup } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { BottomPopupService } from '@ui/bottom-popup/bottom-popup.service';
import {LocationsListComponent} from "@accounts/user/components/locations-list/locations-list.component";
import {FiltersListComponent} from "@accounts/user/components/filters-list/filters-list.component";
import {ActivatedRoute} from "@angular/router";
import {GasStationModel} from "@core/api";

enum View {
  LIST = 'list',
  MAP = 'map'
}

@Component({
  selector: 'user-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
})
export class MapComponent{

  VIEW = View;

  isSmallScreen: boolean;
  viewType: View = View.MAP;

  form: FormGroup = new FormGroup({
    hours: new FormControl(this.tariffService.customTariff.value)
  });

  map = null;
  markers = new Set<GasStationModel>();

  constructor(
    public breakpointObserver: BreakpointObserver,
    private tariffService: TariffService,
    public stationService: StationService,
    public mapService: MapService,
    private bottomPopup: BottomPopupService,
    private route: ActivatedRoute,
  ) {
    this.setupBreakpoint();
    this.setupTariffObserver();
  }

  setupBreakpoint() {
    this.breakpointObserver.observe([
      Breakpoints.XSmall,
      Breakpoints.Small
    ]).subscribe(state => {
      this.isSmallScreen = state.matches;
    });
  }

  setupTariffObserver() {
    this.form.controls['hours'].valueChanges
      .pipe(
        debounceTime(350),
        distinctUntilChanged()
      )
      .subscribe(hours => {
        if (hours && this.form.controls['hours'].valid) {
          this.tariffService.changeCurrentTariff(hours);
        }
      });
  }

  changeViewType({ value }) {
    this.viewType = value;
  }

  goToCurrentStation() {
    this.mapService.goToCurrentStation(
      this.stationService.station.coordinate_latitude,
      this.stationService.station.coordinate_longitude
    );
  } 

  mapReady() {  
    this.mapService.mapReady(); 
    const stationId = Number(this.route.snapshot.paramMap.get('stationId'));
    let shouldStop = false;

    if (stationId) {
      const timer = setInterval(() => {
        this.mapService.markers.forEach((marker) => {
          if (shouldStop) {
            clearInterval(timer);
            return;
          }

          if (marker.id === stationId) {
            this.mapService.selectMarker(marker);
            shouldStop = true;
          }
        });
      }, 100);
    }
  }

  openLocationsList() {
    this.bottomPopup.open(LocationsListComponent, {headerText: "Список локаций"});
  }

  openFiltersList() {
    this.bottomPopup.open(FiltersListComponent, {headerText: "Фильтры"});
  }

  ngOnInit() {
    ymaps.ready(() => this.mapReady());
  }
}
